module.exports = __webpack_public_path__ + "static/media/pep-circle-newsletter.a06d4396.png";